const RELATIONSHIPS = { unspecified: 'Neuvedeno', family: 'Rodina', friend: 'Přítel / přítelkyně', colleague: 'Pracovní kolega / kolegyně', acquaintance: 'Známý / známá', other: 'Jiný vztah' };
const AUDIENCES = { public: 'Veřejné', private: 'Soukromé', family: 'Pouze rodina', family_friends: 'Rodina a přátelé' };

function contributorFields(body, defaults = {}) {
  const read = (key, fallback) => (body[key] === undefined ? (defaults[key] ?? fallback) : body[key]);
  const relationship = read('relationship', 'unspecified');
  const audience = read('audience', 'public');
  const email = read('email', '');
  const detail = read('relationship_detail', '');
  if (!Object.hasOwn(RELATIONSHIPS, relationship) || !Object.hasOwn(AUDIENCES, audience)) throw Object.assign(new Error('Invalid relationship or audience.'), { status: 400 });
  if (typeof email !== 'string' || email.length > 254 || (email && !/^[^\s@<>\r\n]+@[^\s@<>\r\n]+\.[^\s@<>\r\n]+$/.test(email))) throw Object.assign(new Error('Enter a valid email address.'), { status: 400 });
  if (typeof detail !== 'string' || detail.length > 255 || (relationship === 'other' && !detail.trim())) throw Object.assign(new Error('Specify the relationship.'), { status: 400 });
  return { email: email.trim(), relationship, relationship_detail: relationship === 'other' ? detail.trim() : '', audience };
}

module.exports = { RELATIONSHIPS, AUDIENCES, contributorFields };
